<template>
  <img
    src="/logo.svg"
    alt="ThorDocs"
    height="40"
    width="40"
    style="height: 40px; width: 40px; object-fit: contain;"
  >
</template>

<script>
export default {
  name: 'ProjectLogo'
}
</script>
